import { useEffect, useMemo, useState } from 'react';
import { getDatasDisponiveis } from '../services/carteiraDiariaService';

const toLocalIso = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export interface UseDatasDisponiveisReturn {
  datasDisponiveis: string[];
  loading: boolean;
  shouldDisableDate: (d: Date) => boolean;
  toLocalIso: (d: Date) => string;
  toDatePickerValue: (iso: string) => Date | null;
}

export const useDatasDisponiveis = (
  fundoId: number,
  isOpen: boolean,
): UseDatasDisponiveisReturn => {
  const [datasDisponiveis, setDatasDisponiveis] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setDatasDisponiveis([]);
      return;
    }
    setLoading(true);
    getDatasDisponiveis(fundoId)
      .then(setDatasDisponiveis)
      .catch(() => setDatasDisponiveis([]))
      .finally(() => setLoading(false));
  }, [isOpen, fundoId]);

  const datasSet = useMemo(() => new Set(datasDisponiveis), [datasDisponiveis]);

  const shouldDisableDate = (d: Date) =>
    datasDisponiveis.length > 0 && !datasSet.has(toLocalIso(d));

  const toDatePickerValue = (iso: string): Date | null =>
    iso ? new Date(iso + 'T12:00:00') : null;

  return { datasDisponiveis, loading, shouldDisableDate, toLocalIso, toDatePickerValue };
};
